<button [disabled]="isDisabled" [ngClass]="{maxWidth: maxWidth, isDisabled: isDisabled, active: isActive}"
        class="lps-button-filters">
    <lps-icon *ngIf="icon" class="lps-button-filters__icon" icon="{{icon}}"></lps-icon>
    <div class="lps-button-filters__content">
        <span>
            <ng-content></ng-content>
        </span>
    </div>
</button>
